import { useRouter } from 'next/router';
import { formatFacets, getRealLocale } from 'utils/helpers';
import { getLandingPageData as apiGetProductCategory } from 'services/landingPages';
import useSWR from 'swr';

export default function useLanding(productCategoryId, initialData, page, selectedSort, selectedFilters) {
  const router = useRouter();
  const locale = getRealLocale(router.locale);
  const url = `${locale}/api/v1/landing/${productCategoryId}`;
  const fetcher = () =>
    apiGetProductCategory(locale, productCategoryId, page, selectedSort, selectedFilters).then((res) => res.data);

  const {
    data: productCategoryData,
    error,
    mutate,
  } = useSWR(
    [
      url,
      locale,
      productCategoryId,
      JSON.stringify(page),
      JSON.stringify(selectedSort),
      JSON.stringify(selectedFilters),
    ],
    fetcher,
    { initialData }
  );

  return {
    mutate,
    url,
    productCategoryData: productCategoryData
      ? { ...productCategoryData, facets: formatFacets(productCategoryData?.facets) }
      : { ...initialData, facets: formatFacets(initialData?.facets) },
    error,
  };
}
